import { produce } from 'immer';

import { UpdateImagesInternalForGalleryEdit } from '../../../actions/imageEditor/internal/updateImagesInternalForGalleryEdit';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { ImageEditorsState } from '../../../typings/state';

export function updateImagesInternalForGalleryEdit(
    state: ImageEditorsState,
    action: UpdateImagesInternalForGalleryEdit
): ImageEditorsState {
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);

    return produce(state, draft => {
        draft[id].imageGallery.images = action.images;
    });
}
